import { getToken } from '../Auth/auth.reducer';
import { completeRehydration } from './config.actions';
import { take, fork, select, call } from 'redux-saga/effects';
import { fetchAllCategoriesForAppId } from '../Entities/Categories/categories.saga';
import { fetchAllBrandsForAppId } from '../Entities/Brands/brands.saga';
import { fetchAllIdols } from '../Entities/Idols/idols.saga';
import { fetchOutfitsForAppConfig } from '../StoryEdit/story-edit.saga';

export const APP_CONFIGS = {
  139: {
    apiUrl: 'https://m.aboutyou.de',
    topCategories: [
      { id: 20201, name: 'Frauen', normalized: 'frauen', gender: true },
      { id: 20201, name: 'Männer', normalized: 'maenner', gender: true },
      { id: 138113, name: 'Kinder', normalized: 'kinder', gender: false },
    ],
  },
  200: {
    apiUrl: 'https://m.aboutyou.at',
    topCategories: [
      { id: 77134, name: 'Frauen', normalized: 'frauen', gender: true },
      { id: 77333, name: 'Männer', normalized: 'maenner', gender: true },
      { id: 138155, name: 'Kinder', normalized: 'kinder', gender: false },
    ],
  },
  431: {
    apiUrl: 'https://m.aboutyou.ch',
    topCategories: [
      { id: 144447, name: 'Frauen', normalized: 'frauen', gender: true },
      { id: 145125, name: 'Männer', normalized: 'maenner', gender: true },
      { id: 145498, name: 'Kinder', normalized: 'kinder', gender: false },
    ],
  },
  545: {
    apiUrl: 'https://m.aboutyou.nl',
    topCategories: [
      { id: 20201, name: 'Dames', normalized: 'dames', gender: true },
      { id: 20202, name: 'Heren', normalized: 'heren', gender: true },
      { id: 138113, name: 'Kinderen', normalized: 'kinderen', gender: true },
    ],
  },
  558: {
    apiUrl: 'https://m.aboutyou.be',
    topCategories: [
      { id: 20201, name: 'Dames', normalized: 'dames', gender: true },
      { id: 20202, name: 'Heren', normalized: 'heren', gender: true },
      { id: 138113, name: 'Kinderen', normalized: 'kinderen', gender: false },
    ],
  },
  562: {
    apiUrl: 'https://m-fr.aboutyou.be',
    topCategories: [
      { id: 20201, name: 'Femme', normalized: 'femme', gender: true },
      { id: 20202, name: 'Homme', normalized: 'homme', gender: true },
      { id: 138113, name: 'Enfants', normalized: 'enfants', gender: false },
    ],
  },
  566: {
    apiUrl: 'https://m-fr.aboutyou.ch',
    topCategories: [
      { id: 144447, name: 'Femme', normalized: 'femme', gender: true },
      { id: 145125, name: 'Homme', normalized: 'homme', gender: true },
      { id: 145498, name: 'Enfants', normalized: 'enfants', gender: false },
    ],
  },
  550: {
    apiUrl: 'https://m.aboutyou.pl',
    topCategories: [
      { id: 20201, name: 'Kobiety', normalized: 'kobiety', gender: true },
      { id: 20202, name: 'Mężczyźni', normalized: 'mezczyzni', gender: true },
      { id: 138113, name: 'Dzieci', normalized: 'dzieci', gender: false },
    ],
  },
  554: {
    apiUrl: 'https://m.aboutyou.cz',
    topCategories: [
      { id: 20201, name: 'Zeny', normalized: 'zeny', gender: true },
      { id: 20202, name: 'Muzi', normalized: 'muzi', gender: true },
      { id: 138113, name: 'Deti', normalized: 'deti', gender: false },
    ],
  },
  594: {
    apiUrl: 'https://m.aboutyou.ro',
    topCategories: [
      { id: 20201, name: 'Femei', normalized: 'femei', gender: true },
      { id: 20202, name: 'Barbati', normalized: 'barbati', gender: true },
      { id: 138113, name: 'Copii', normalized: 'copii', gender: false },
    ],
  },
  590: {
    apiUrl: 'https://m.aboutyou.hu',
    topCategories: [
      { id: 20201, name: 'Noi', normalized: 'noi', gender: true },
      { id: 20202, name: 'Ferfi', normalized: 'ferfi', gender: true },
      { id: 138113, name: 'Gyerek', normalized: 'gyerek', gender: false },
    ],
  },
  586: {
    apiUrl: 'https://m.aboutyou.sk',
    topCategories: [
      { id: 20201, name: 'Zeny', normalized: 'zeny', gender: true },
      { id: 20202, name: 'Muzi', normalized: 'muzi', gender: true },
      { id: 138113, name: 'Deti', normalized: 'deti', gender: false },
    ],
  },
  617: {
    apiUrl: 'https://m.aboutyou.si',
    topCategories: [
      { id: 20201, name: 'Ženske', normalized: 'zenske', gender: true },
      { id: 20202, name: 'Moški', normalized: 'moski', gender: true },
      { id: 138113, name: 'Otroci', normalized: 'otroci', gender: false },
    ],
  },
  622: {
    apiUrl: 'https://m.aboutyou.lv',
    topCategories: [
      { id: 20201, name: 'Sievietēm', normalized: 'sievietem', gender: true },
      { id: 20202, name: 'Vīriešiem', normalized: 'viriesiem', gender: true },
      { id: 138113, name: 'Bērniem', normalized: 'berniem', gender: false },
    ],
  },
  627: {
    apiUrl: 'https://m.aboutyou.lt',
    topCategories: [
      { id: 20201, name: 'Moterims', normalized: 'moterims', gender: true },
      { id: 20202, name: 'Vyrams', normalized: 'vyrams', gender: true },
      { id: 138113, name: 'Vaikams', normalized: 'vaikams', gender: false },
    ],
  },
  632: {
    apiUrl: 'https://m.about-you.ee',
    topCategories: [
      { id: 20201, name: 'Naised', normalized: 'naised', gender: true },
      { id: 20202, name: 'Mehed', normalized: 'mehed', gender: true },
      { id: 138113, name: 'Lapsed', normalized: 'lapsed', gender: false },
    ],
  },
  637: {
    apiUrl: 'https://m.about-you.hr',
    topCategories: [
      { id: 20201, name: 'Žene', normalized: 'zene', gender: true },
      { id: 20202, name: 'Muškarci', normalized: 'muskarci', gender: true },
      { id: 138113, name: 'Djeca', normalized: 'djeca', gender: false },
    ],
  },
  642: {
    apiUrl: 'https://m.aboutyou.bg',
    topCategories: [
      { id: 20201, name: 'Жени', normalized: 'zheni', gender: true },
      { id: 20202, name: 'Мъже', normalized: 'mazhe', gender: true },
      { id: 138113, name: 'Деца', normalized: 'detsa', gender: false },
    ],
  },
  654: {
    apiUrl: 'https://m-dk.aboutyou.com',
    topCategories: [
      { id: 20201, name: 'Kvinder', normalized: 'kvinder', gender: true },
      { id: 20202, name: 'Mænd', normalized: 'maend', gender: true },
      { id: 138113, name: 'Børn', normalized: 'boern', gender: false },
    ],
  },
  655: {
    apiUrl: 'https://m-se.aboutyou.com',
    topCategories: [
      { id: 20201, name: 'Kvinnor', normalized: 'kvinnor', gender: true },
      { id: 20202, name: 'Män', normalized: 'maen', gender: true },
      { id: 138113, name: 'Barn', normalized: 'barn', gender: false },
    ],
  },
  656: {
    apiUrl: 'https://m-fi.aboutyou.com',
    topCategories: [
      { id: 20201, name: 'Naiset', normalized: 'naiset', gender: true },
      { id: 20202, name: 'Miehet', normalized: 'miehet', gender: true },
      { id: 138113, name: 'Lapset', normalized: 'lapset', gender: false },
    ],
  },
  658: {
    apiUrl: 'https://m.aboutyou.fr',
    topCategories: [
      { id: 20201, name: 'Femme', normalized: 'femme', gender: true },
      { id: 20202, name: 'Homme', normalized: 'homme', gender: true },
      { id: 138113, name: 'Enfants', normalized: 'enfants', gender: false },
    ],
  },
  670: {
    apiUrl: 'https://m.aboutyou.es',
    topCategories: [
      { id: 20201, name: 'Mujer', normalized: 'mujer', gender: true },
      { id: 20202, name: 'Hombre', normalized: 'hombre', gender: true },
      { id: 138113, name: 'Infantil', normalized: 'infantil', gender: false },
    ],
  },
  671: {
    apiUrl: 'https://m.aboutyou.it',
    topCategories: [
      { id: 20201, name: 'Donna', normalized: 'donna', gender: true },
      { id: 20202, name: 'Uomo', normalized: 'uomo', gender: true },
      { id: 138113, name: 'Bambini', normalized: 'bambini', gender: false },
    ],
  },
  685: {
    apiUrl: 'https://m.aboutyou.pt',
    topCategories: [
      { id: 20201, name: 'Mulheres', normalized: 'mulheres', gender: true },
      { id: 20202, name: 'Homens', normalized: 'homens', gender: true },
      { id: 138113, name: 'Crianças', normalized: 'criancas', gender: false },
    ],
  },
  686: {
    apiUrl: 'https://m.aboutyou.gr',
    topCategories: [
      { id: 20201, name: 'Γυναίκα', normalized: 'ginaikes', gender: true },
      { id: 20202, name: 'Άνδρας', normalized: 'andres', gender: true },
      { id: 138113, name: 'Παιδί', normalized: 'paidia', gender: false },
    ],
  },
  688: {
    apiUrl: 'https://m-en.aboutyou.de',
    topCategories: [
      { id: 20201, name: 'Women', normalized: 'women', gender: true },
      { id: 20202, name: 'Men', normalized: 'men', gender: true },
      { id: 138113, name: 'kids', normalized: 'kids', gender: false },
    ],
  },
  692: {
    apiUrl: 'https://m.aboutyou.com',
    topCategories: [
      { id: 20201, name: 'Women', normalized: 'women', gender: true },
      { id: 20202, name: 'Men', normalized: 'men', gender: true },
      { id: 138113, name: 'kids', normalized: 'kids', gender: false },
    ],
  },
  693: {
    apiUrl: 'https://m-es.aboutyou.com',
    topCategories: [
      { id: 20201, name: 'Mujer', normalized: 'mujer', gender: true },
      { id: 20202, name: 'Hombre', normalized: 'hombre', gender: true },
      { id: 138113, name: 'Infantil', normalized: 'infantil', gender: false },
    ],
  },
  705: {
    apiUrl: 'https://aboutyou.com.cy',
    topCategories: [
      { id: 20201, name: 'Γυναίκες', normalized: 'ginaikes', gender: true },
      { id: 20202, name: 'Άνδρες', normalized: 'andres', gender: true },
      { id: 138113, name: 'Παιδιά', normalized: 'paidia', gender: false },
    ],
  },
  706: {
    apiUrl: 'https://aboutyou.lu',
    topCategories: [
      { id: 20201, name: 'Femme', normalized: 'femme', gender: true },
      { id: 20202, name: 'Homme', normalized: 'homme', gender: true },
      { id: 138113, name: 'Enfants', normalized: 'enfants', gender: false },
    ],
  },
  715: {
    apiUrl: 'https://it.aboutyou.ch',
    topCategories: [
      { id: 20201, name: 'Donna', normalized: 'donna', gender: true },
      { id: 20202, name: 'Uomo', normalized: 'uomo', gender: true },
      { id: 138113, name: 'Bambini', normalized: 'bambini', gender: false },
    ],
  },
  716: {
    apiUrl: 'https://ru.aboutyou.lv',
    topCategories: [
      { id: 20201, name: 'Женщины', normalized: 'women', gender: true },
      { id: 20202, name: 'Мужчины', normalized: 'men', gender: true },
      { id: 138113, name: 'Дети', normalized: 'kids', gender: false },
    ],
  },
  717: {
    apiUrl: 'https://ru.aboutyou.ee',
    topCategories: [
      { id: 20201, name: 'Женщины', normalized: 'women', gender: true },
      { id: 20202, name: 'Мужчины', normalized: 'men', gender: true },
      { id: 138113, name: 'Дети', normalized: 'kids', gender: false },
    ],
  },
  730: {
    apiUrl: 'https://m-en.aboutyou.ch',
    topCategories: [
      { id: 20201, name: 'Women', normalized: 'women', gender: true },
      { id: 20202, name: 'Men', normalized: 'men', gender: true },
      { id: 138113, name: 'kids', normalized: 'kids', gender: false },
    ],
  },
  731: {
    apiUrl: 'https://m-en.aboutyou.at',
    topCategories: [
      { id: 20201, name: 'Women', normalized: 'women', gender: true },
      { id: 20202, name: 'Men', normalized: 'men', gender: true },
      { id: 138113, name: 'kids', normalized: 'kids', gender: false },
    ],
  },
  732: {
    apiUrl: 'https://m-en.aboutyou.nl',
    topCategories: [
      { id: 20201, name: 'Women', normalized: 'women', gender: true },
      { id: 20202, name: 'Men', normalized: 'men', gender: true },
      { id: 138113, name: 'kids', normalized: 'kids', gender: false },
    ],
  },
};

export function* watchForCompleteRehydration() {
  while (true) {
    yield take(completeRehydration.type);
    yield prepareApp();
  }
}

export function* prepareApp() {
  const state = yield select();
  const token = getToken(state);
  if (token) {
    yield call(prepareCategoriesAndBrandsAndOutfits);
    yield fork(fetchAllIdols);
  }
}

export function* prepareCategories(appId: number) {
  const {
    entities: { categories },
  } = yield select();
  if (!categories[appId]) {
    yield fetchAllCategoriesForAppId(appId);
  }
}

export function* prepareBrands(appId: number) {
  const {
    entities: { brands },
  } = yield select();
  if (!brands[appId]) {
    yield fetchAllBrandsForAppId(appId);
  }
}

export function* prepareOutfits(appId: number) {
  const {
    entities: { outfits },
  } = yield select();
  if (!outfits[appId]) {
    yield fetchOutfitsForAppConfig();
  }
}

export function* prepareCategoriesAndBrandsForAppId(appId: number) {
  yield fork(prepareCategories, appId);
  yield fork(prepareBrands, appId);
}

export function* prepareCategoriesAndBrands() {
  const {
    storyEdit: { activeAppId },
  } = yield select();

  yield fork(prepareCategories, activeAppId || 139);
  yield fork(prepareBrands, activeAppId || 139);
}

export function* prepareCategoriesAndBrandsAndOutfits() {
  const {
    storyEdit: { activeAppId },
  } = yield select();

  yield fork(prepareCategories, activeAppId || 139);
  yield fork(prepareBrands, activeAppId || 139);
  yield fork(prepareOutfits, activeAppId || 139);
}

export function* prepareCategoriesAndBrandsAndOutfitsForAppId(appId: number) {
  yield fork(prepareCategories, appId);
  yield fork(prepareBrands, appId);
  yield fork(prepareOutfits, appId);
}



// WEBPACK FOOTER //
// ./src/store/Config/config.saga.ts